import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { contentStyles } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import Image from '@stories/Components/Misc/Image/Image';
import styled from 'styled-components';
const Container = styled.div `
  [data-card-theme='dark'] & {
    --cardBgColor: ${brand.primary.blue};
    --cardFgColor: ${brand.white};
    --cardNumberColor: ${brand.base.blue};
  }

  &[data-has-image='true'] {
    display: flex;
    flex-direction: column;
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  overflow: hidden;
  padding: ${fluid(20, 44)} ${fluid(20, 32)};
  border-radius: 6px;
  background-color: var(--cardBgColor, ${brand.primary.blueGrey});
  color: var(--cardFgColor, ${brand.primary.blue});
  height: 100%;

  ${Container}[data-has-image='true'] & {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    height: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  ${CtaLinkStyles.Container},
  ${ButtonStyles.Container} {
    margin: ${fluid(20, 36)} 0 0;
  }

  ${CtaLinkStyles.Container} {
    ${fonts.apparat.semiBold};

    font-size: ${fluid(18, 20)};
    line-height: ${fluid(18, 20)};
    color: currentColor;
  }

  &[data-number]::after {
    ${fonts.apparat.bold};

    content: attr(data-number);
    font-size: ${fluid(132, 248)};
    line-height: 0.5;
    position: absolute;
    bottom: 0;
    right: ${fluid(28, 56)};
    color: var(--cardNumberColor, ${brand.secondary.blueGrey});

    /* Apply different line height for iOS devices */
    @supports (-webkit-touch-callout: none) {
      line-height: 0.66;
    }
  }
`;
const Title = styled.h3 `
  ${fonts.apparat.semiBold};

  font-size: ${fluid(20, 22)};
  line-height: ${fluid(30, 32)};
  color: currentColor;
  margin: 0 0 16px;
  position: relative;
  z-index: 1;
`;
const Content = styled.div `
  ${contentStyles};

  color: currentColor;
  position: relative;
  z-index: 1;

  ${Container}[data-has-image='true'] & {
    margin-bottom: auto;
  }

  p {
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(26, 28)};

    a {
      color: ${brand.primary.base};
    }
  }
`;
const Icon = styled.div `
  display: grid;
  place-content: center;
  height: ${fluid(66, 100)};
  width: ${fluid(66, 100)};
  margin: 0 0 ${fluid(16, 32)};
  background-color: currentColor;
  border-radius: 5000px;

  > img {
    display: block;
    max-width: ${fluid(40, 60)};
    max-height: ${fluid(40, 60)};
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(428, 241)};

  border-radius: 6px 6px 0 0;
`;
const Img = styled(Image) `
  ${imageCoverContainer()};
`;
const CalloutCardStyles = {
    Container,
    ContentWrapper,
    Title,
    Content,
    Icon,
    ImageWrapper,
    Img,
};
export default CalloutCardStyles;
